import { initRawSchema } from '@principle-theorem/editor';
import {
  IPracticeSetupStep,
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { toTimestamp, WithRef } from '@principle-theorem/shared';
import { MockWithRef } from '@principle-theorem/testing';
import { PracticeSetupStep } from './practice-setup-step';

export function MockPracticeSetupStep(
  overrides: Partial<WithRef<IPracticeSetupStep>> = {},
  pathOverride?: string
): WithRef<IPracticeSetupStep> {
  const step = PracticeSetupStep.init({
    id: PracticeSetupStepId.PracticeInfo,
    category: PracticeSetupStepCategory.GeneralPracticeSettings,
    title: 'Practice Info',
    description: initRawSchema('Enter practice details'),
    ...overrides,
  });
  return {
    ...MockWithRef(step, pathOverride ?? `setupWizardSteps/${step.id}`),
    createdAt: toTimestamp(),
    updatedAt: toTimestamp(),
  };
}
